import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Box,
} from "@mui/material";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
import { Link, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../../services/context/AuthContext";

type Payment = {
  booking_txn_id: string;
  user_name: string;
  corporate_user: string;
  amount: number;
  payment_mode: string;
  date: string;
};

type RecentPaymentsProps = {
  payments: Payment[];
};

const RecentPayments = ({ payments }: RecentPaymentsProps) => {
  const hasData = payments && payments.length > 0;

  const { userInfo } = useGlobalState();
  const currency = userInfo?.currencyCode || "AED";

  return (
    <div className="card h-full">
      <div className="card-header dashboard-card-header">
        <h6 className="mb-0 fw-semibold">Recent Payments</h6>
        <Link to={"/paymentcard"}>
          <button
            type="button"
            className="text-decoration-none btn btn-link btn-sm veiw-all-btn"
          >
            View All <ArrowOutwardOutlinedIcon sx={{ fontSize: 16 }} />
          </button>
        </Link>
      </div>
      {/* <CardHeader
        title={<Typography variant="h6">Recent Payments</Typography>}
      /> */}
      <CardContent sx={{ p: 0, height: "320px", overflowY: "auto" }}>
        {hasData ? (
          <List>
            {payments.map((item, index) => (
              <ListItem
                key={index}
                secondaryAction={
                  <Typography variant="caption" color="text.secondary">
                    {new Date(item.date).toLocaleString()} {/* date + time */}
                  </Typography>
                }
              >
                <ListItemAvatar>
                  <Avatar>{item.user_name[0]}</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2">
                      {item.user_name} • {currency}
                      {item.amount}
                    </Typography>
                  }
                  secondary={`${item.payment_mode.toUpperCase()} ${
                    item.corporate_user !== "N/A"
                      ? `• ${item.corporate_user}`
                      : ""
                  }`}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "280px",
            }}
          >
            <Typography variant="body2" align="center">
              No payments found
            </Typography>
          </Box>
        )}
      </CardContent>
    </div>
  );
};

export default RecentPayments;
